// Recovered compiled webpack factory 44554. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { Z: () => s });
  var n = i(28634);
  function s(t) {
    let e = [0];
    return ((0, n.f)(e, t.length - 1), e);
  }
}
